module.exports = "/images/Acquire new customers.svg?bf5d37f0a9e5b1564e66d0641a0d3bb6";